import React, { useState, useEffect } from 'react';
import axios from 'axios';
import RoomTypeFacilityModal from './RoomTypeFacilityModal';
import { API_BASE } from '../../config/apiBase';

const API = `${API_BASE}/manager/website`;

export default function RoomTypeFacilitiesTab({ token }) {
    const [facilities, setFacilities] = useState([]);
    const [roomTypes, setRoomTypes] = useState([]);
    const [modal, setModal] = useState({ open: false, editIndex: null, data: null, hotelRoomTypeId: null });

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);

    // Fetch all room types and their facilities
    async function fetchData() {
        try {
            // Fetch all room types and all facilities in one call
            const res = await axios.get(`${API}/room-type-facilities`, { headers: { Authorization: `Bearer ${token}` } });
            setRoomTypes(res.data.data.roomTypes);
            setFacilities(res.data.data.facilities);
        } catch (err) {
            console.error('Error fetching room types or facilities:', err);
        }
    }

    async function handleAddEdit(data, editIndex, hotelRoomTypeId) {
        console.log('================ HANDLE ADD / EDIT =================');
        console.log('Incoming arguments:', {
            data,
            editIndex,
            hotelRoomTypeId,
            tokenPresent: !!token
        });

        try {
            // SAFETY CHECK
            if (!hotelRoomTypeId) {
                console.error('❌ hotelRoomTypeId is UNDEFINED or NULL');
                alert('Internal error: room type id missing');
                return;
            }

            if (editIndex != null && facilities[editIndex]) {
                // ================= EDIT =================
                const facility = facilities[editIndex];
                const id = facility.facility_id;

                console.log('✏️ EDIT MODE');
                console.log('Editing facility:', facility);
                console.log('PUT URL:', `${API}/room-type-facilities/${hotelRoomTypeId}/${id}`);
                console.log('Payload:', data);

                const res = await axios.put(
                    `${API}/room-type-facilities/${hotelRoomTypeId}/${id}`,
                    data,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                console.log('✅ PUT response:', res.data);

                setFacilities(facs =>
                    facs.map((f, i) => (i === editIndex ? res.data.data : f))
                );

            } else {
                // ================= ADD =================
                console.log('➕ ADD MODE');
                console.log('POST URL:', `${API}/room-type-facilities/${hotelRoomTypeId}`);
                console.log('Payload:', data);

                const res = await axios.post(
                    `${API}/room-type-facilities/${hotelRoomTypeId}`,
                    data,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                console.log('✅ POST response:', res.data);

                setFacilities(facs => [...facs, res.data.data]);
            }

            console.log('🟢 Closing modal');
            setModal({
                open: false,
                editIndex: null,
                data: null,
                hotelRoomTypeId: null
            });

        } catch (err) {
            console.error('❌ API ERROR in handleAddEdit');
            console.error('Error object:', err);
            console.error('Response:', err.response);
            console.error('Status:', err.response?.status);
            console.error('Message:', err.response?.data);

            alert(err.response?.data?.message || 'Failed to save facility');
        }
    }


    async function handleDelete(id, roomTypeId) {
        if (!window.confirm('Are you sure you want to delete this facility?')) return;
        try {
            await axios.delete(`${API}/room-type-facilities/${roomTypeId}/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setFacilities(facs => facs.filter(f => !(f.facility_id === id && f.hotel_room_type_id === roomTypeId)));
        } catch (err) {
            alert(err.response?.data?.message || 'Failed to delete facility');
        }
    }

    return (
        <div style={{ marginTop: 18, marginLeft: 12, borderLeft: '2px solid #e5e7eb', paddingLeft: 16 }}>
            <div>
                {roomTypes.map(rt => (
                                        <div key={rt.id} style={{ marginBottom: 24 }}>
                                                <h3 style={{
                                                    color: '#0a2540',
                                                    fontWeight: 800,
                                                    marginBottom: 4,
                                                    fontSize: '1.5rem',
                                                    letterSpacing: '0.03em',
                                                    textShadow: '0 1px 6px rgba(42,100,176,0.10)',
                                                    borderLeft: '6px solid #3182ce',
                                                    paddingLeft: 14,
                                                    background: 'linear-gradient(90deg, #e6f0fa 60%, #fff 100%)',
                                                    borderRadius: 6,
                                                    display: 'inline-block',
                                                    boxShadow: '0 1px 6px rgba(49,130,206,0.07)'
                                                }}>{rt.room_type}</h3>
                        <div style={{ margin: '8px 0 0 0' }}>
                            <button
                                className="add-facility-btn"
                                style={{
                                    padding: '5px 12px',
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: '#fff',
                                    background: 'linear-gradient(90deg, #3182ce 60%, #63b3ed 100%)',
                                    border: 'none',
                                    borderRadius: 5,
                                    boxShadow: '0 2px 8px rgba(49,130,206,0.13)',
                                    cursor: 'pointer',
                                    marginTop: 0,
                                    marginBottom: 6,
                                    transition: 'background 0.2s, box-shadow 0.2s',
                                }}
                                onMouseOver={e => {
                                    e.currentTarget.style.background = 'linear-gradient(90deg, #2563eb 60%, #4299e1 100%)';
                                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(49,130,206,0.18)';
                                }}
                                onMouseOut={e => {
                                    e.currentTarget.style.background = 'linear-gradient(90deg, #3182ce 60%, #63b3ed 100%)';
                                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(49,130,206,0.13)';
                                }}
                                onClick={() => setModal({ open: true, editIndex: null, data: null, hotelRoomTypeId: rt.id })}
                            >
                                <span style={{ fontSize: 15, marginRight: 5, verticalAlign: 'middle' }}>➕</span> Add Facility
                            </button>
                        </div>
                        {facilities.filter(f => f.hotel_room_type_id === rt.id).map((f, idx) => (
                            <div key={f.facility_id || idx} className="facility-card" style={{ margin: '10px 0', background: '#f9fafb' }}>
                                <div className="facility-card-header" onClick={() => setModal({ open: true, editIndex: idx, data: f, hotelRoomTypeId: rt.id })}>
                                    <span className="facility-card-title">{f.name}</span>
                                </div>
                                <div className="facility-card-details">
                                    <div><b>Description:</b> {f.description}</div>
                                    <div className="facility-card-actions">
                                        <button onClick={() => setModal({ open: true, editIndex: idx, data: f, hotelRoomTypeId: rt.id })}>Edit</button>
                                        <button onClick={() => handleDelete(f.facility_id, rt.id)} className="delete">Delete</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {facilities.filter(f => f.hotel_room_type_id === rt.id).length === 0 && (
                            <div style={{ color: '#888', textAlign: 'center', margin: '12px 0' }}>No facilities for this room type.</div>
                        )}
                    </div>
                ))}
            </div>

            {modal.open && (
                <RoomTypeFacilityModal
                    initial={modal.data}
                    onClose={() => setModal({ open: false, editIndex: null, data: null, hotelRoomTypeId: null })}
                    onSave={data => handleAddEdit(data, modal.editIndex, modal.hotelRoomTypeId)}
                />
            )}
        </div>
    );
}
